import React from 'react'
import TinySadImg from '../assets/tinysad.png'
import styled from 'styled-components';

const StyledImg = styled.img`
margin-right: auto;
margin-left: auto;
display: block;
`;

const TinySad = () => <StyledImg src={TinySadImg} alt="tinysad image" />

export default TinySad